export default status => {
  if (status === 'TERMINAL') {
    return 'Terminal';
  } if (status === 'SERVICE') {
    return 'Service';
  } return 'Other';
};
